import React, {Component, useState, useEffect} from 'react';
import AddressSearchBar from '../../addressSearchBar/js/AddressSearchBar.jsx';
import {utils} from '../../../../global/js/utils.js';
import queryString from 'global/js/query-string.js';

const SimpleLocationSearchBar = (props) => {
	const [address, setAddress] = useState('');
	// const [filters, setFilters] = useState(props.filters);
	const [userLocation, setUserLocation] = useState({lat: null, lng: null});

	const [showMoreFiltersDialogue, setShowMoreFiltersDialogue] = useState(false);

	const handleToggleFilters = () => {
		setShowMoreFiltersDialogue(!showMoreFiltersDialogue);
	};

	// useEffect(() => {
	// 	if (userLocation.lat && userLocation.lng) {
	// 		const { href } = window.location;
	// 		console.log(userLocation);
	// 		window.history.replaceState("", "", utils.updateURLParameter(href, "lng", userLocation.lng));
	// 		window.history.replaceState("", "", utils.updateURLParameter(href, "lat", userLocation.lat));

	// 	}
	// }, [userLocation]);

	useEffect(() => {
		const parsedQuery = utils.getLocationFromStorage();
		const urlQueryAddress = parsedQuery.address;
		// const urlQueryCarParkFeature = parsedQuery.carParkFeature;

		// if (urlQueryCarParkFeature && urlQueryCarParkFeature != "") {
			// let featureArr = urlQueryCarParkFeature.split(",");
			// props.setSelectedMoreFilters(featureArr);
		// }

		if (urlQueryAddress && urlQueryAddress != '') {
			setAddress(urlQueryAddress);
		} else {
			// eslint-disable-next-line no-undef
			let geocoder = new google.maps.Geocoder();
			navigator.geolocation.getCurrentPosition((position) => {
				const {latitude, longitude} = position.coords;
				setUserLocation({lat: latitude, lng: longitude});
				geocodeLatLng(geocoder, {lat: latitude, lng: longitude});
			});
		}
	}, []);

	const geocodeLatLng = (geocoder, latlng) => {
		geocoder.geocode({location: latlng}, function(results, status) {
			if (status === 'OK') {
				if (results[0]) {
					setAddress(results[0].formatted_address);
					// window.history.replaceState(
					// 	'',
					// 	'',
					// 	utils.updateURLParameter(window.location.href, 'address', results[0].formatted_address)
					// );
					const _location = queryString.parse(localStorage.getItem('userLocation')) || {};
					_location['address'] = results[0].formatted_address;
					_location['lat'] = latlng.lat;
					_location['lng'] = latlng.lng;
					localStorage.setItem('userLocation', $.param(_location));
				} else {
					return;
				}
			} else {
				console.log('Geocoder failed due to: ' + status);
			}
		});
	};

	/**
	 * these 3 functions are for filters
	 * @function handleFilterChange for filter checkbox event
	 * @function applyFilters callback for carpark data api call
	 * @function renderFilters render filters from props data
	 */

	const renderFilters = () => {
		return (
			<div className="filter-panel">
				{props.filters.map((filter, index) => (
					<div className="product" key={index}>
						<label title={filter.name} className={filter.name}>
							<input data-key={filter.key}
								name={filter.name}
								type="checkbox"
								checked={filter.filtered}
								onChange={(e) => handleFilterChange(e, filter)}/>
							<span>{filter.name}</span>
						</label>
					</div>
				))}
				<button className="btn btn-primary apply-filters" onClick={() => applyFilters()}>Apply</button>
			</div>
		);
	};

	const handleFilterChange = (event, filter) =>	{
		console.log(filter);
		if(event.target.checked != null) {
			let oneFilter = {};
			oneFilter = {
				name: filter.name,
				key: filter.key,
				filtered: event.target.checked,
			};

			console.log(oneFilter);
			props.updateFilters(oneFilter);
		}
	};

	const applyFilters = () => {
		setShowMoreFiltersDialogue(false);
		props.applyFilters();
	};

	return (
		<div id="simpleLocationSearchBar" className="simpleLocationSearchBar py-4">
			<div className="container">
				<h2 className="mb-3">{props.mainTitle}</h2>
				<div className="row">
					<div className="col-12 col-lg-4">
						<div className="addressSearchBar-react">
							<AddressSearchBar
								// setUserLocation={setUserLocation}
								// handleActiveInput={handleActiveInput}
								useCurrentLocation={false}
								getAddress={address && address}
								fetchParkings={props.fetchParkings}
								fetchRecommendedParkings={props.fetchRecommendedParkings}
								country={props.country}
							/>
						</div>
					</div>
					<div className="col-12 col-lg-8 d-flex justify-content-between justify-content-lg-start px-0 px-lg-3">
						<div className="row w-100 mx-auto">
							<div className="col-12 col-lg-4 position-relative">
								{
									props.carparkfeature &&
									<div
										className="filters-label filterInput filters-holder pointer"
										onClick={() => handleToggleFilters()}
									>
										<span className="input-label more-filters w-100">Car park features</span>
										<div className="icon-chevron-down fsp-24" />
									</div>
								}

								{
									showMoreFiltersDialogue && props.carparkfeature &&
									renderFilters()
								}


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SimpleLocationSearchBar;
